const MICRO = 1_000_000;

const usd = new Intl.NumberFormat("en-US", {
  currency: "USD",
  style: "currency",
});

export function formatMicroUsd(microUsd: number): string {
  if (microUsd > 0 && microUsd < MICRO / 100) return "< $0.01";

  return usd.format(microUsd / MICRO);
}

const unitUsd = new Intl.NumberFormat("en-US", {
  currency: "USD",
  maximumFractionDigits: 4,
  minimumFractionDigits: 2,
  style: "currency",
});

export function formatUnitUsd(value: number): string {
  return unitUsd.format(value);
}
